import React from 'react'

function Svg2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.253 10.615C9.113 7.431 8.547 6.022 9.21 5.569c.504-.332 3.465 2.507 5.04 4.383"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.002 11.048h0l.176-.032-.176.032zm0 0a.18.18 0 01-.202-.126c-.008-.084.044-.14.1-.153l.189-.026.01-.001m-.097.306l.097-.306m0 0l.011-.002m-.01.002l.01-.002m0 0c.098-.018.161.043.172.104.018.097-.042.161-.104.172l-.068-.276zM14.703 11.535h0l-.014.003c-.018.003-.048.002-.084-.022a.2.2 0 01-.077-.103c-.008-.087.049-.144.107-.154l.175-.032h0c.098-.017.162.043.173.104.017.098-.043.161-.105.173h0l-.175.031zM12.43 12.026h0l.177-.032-.176.032zm0 0c-.097.017-.16-.043-.171-.104-.018-.098.042-.161.104-.172h0m.068.276l-.068-.276m0 0l.176-.032s0 0 0 0c.097-.018.16.043.172.104.017.097-.043.161-.104.172l-.244-.244zM10.131 12.512h0l.176-.031.088.492-.088-.492c.062-.011.122-.075.104-.172-.01-.061-.075-.122-.172-.104h0l-.176.031s0 0 0 0m.068.276l.089.493a.65.65 0 01-.753-.508.64.64 0 01.508-.753l.088.492m.068.276l-.013.003a.142.142 0 01-.098-.026.127.127 0 01-.061-.08c-.017-.098.043-.161.104-.173m.068.276l-.068-.276M8.035 12.972h0l-.175.032s0 0 0 0c-.098.017-.162-.043-.173-.104-.017-.098.043-.161.105-.172h0l.175-.032s0 0 0 0c.098-.018.162.043.173.104.017.097-.043.161-.105.172z"
        stroke="currentColor"
      />
      <mask id="2_svg__a" fill="#fff">
        <path d="M21.595 9.254l-2.18.454a.64.64 0 10.245 1.257l2.532-.518" />
      </mask>
      <path
        d="M19.415 9.708l.175.984.014-.003.014-.002-.203-.98zm.245 1.256l.175.984.012-.002.012-.002-.199-.98zm1.733-2.689l-2.18.454.404 1.958 2.18-.454-.404-1.958zm-2.152.449c-.929.166-1.475 1.052-1.32 1.914l1.97-.36a.364.364 0 01-.301.414l-.35-1.968zm-1.32 1.914c.169.93 1.06 1.464 1.914 1.31l-.349-1.967a.358.358 0 01.405.298l-1.97.36zm1.938 1.306l2.531-.517-.396-1.959-2.532.517.397 1.959z"
        fill="currentColor"
        mask="url(#2_svg__a)"
      />
      <path
        d="M3.089 13.558l-.23-.912-.282-1.285c-.09-.384.156-.723.513-.817.324-.07.622.057.756.333l.637 1.203.028.004L19.76 8.817c1.094-.252 2.198.472 2.473 1.598.153.765-.324 1.53-1.09 1.683l-5.844 1.201M3.416 14.764c.28.65.912.96 1.858.745l3.967-.852 2.781-.562"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.834 14.332l-2.184.475a.44.44 0 01-.527-.33l-.037-.148a.44.44 0 01.33-.528l2.183-.474a.44.44 0 01.527.33l.037.148a.44.44 0 01-.33.527zM15.353 12.565c-.743 3.763-1.973 7.517-2.78 7.35-.587-.11-.683-4.216-.461-6.677"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Svg2
